import { usePostalCodeExcluded } from "@equidefi/portals/hooks/usePostalCode";
import { Input } from "@equidefi/ui";
import { CountrySelect } from "./CountrySelect";
import { StreetAutocompleteInput } from "./StreetAutocompleteInput";

export const AddressForm = ({ formik, onAddressSelect }) => {
  const { errors, touched, getFieldProps, setFieldValue } = formik;
  const country = getFieldProps("address_country_code").value;
  const street1Props = getFieldProps("address_street_1");
  const hidePostalCode = usePostalCodeExcluded(country, getFieldProps("address_postal_code").value, () =>
    setFieldValue("address_postal_code", ""),
  );

  return (
    <>
      <StreetAutocompleteInput
        label="Street Address"
        isInvalid={touched.address_street_1 && !!errors.address_street_1}
        isRequired
        error={errors.address_street_1}
        onSelected={onAddressSelect}
        {...street1Props}
      />
      <Input
        label="Street Address 2 (Unit #)"
        isInvalid={touched.address_street_2 && !!errors.address_street_2}
        error={errors.address_street_2}
        {...getFieldProps("address_street_2")}
      />
      <Input
        label="City"
        isInvalid={touched.address_city && !!errors.address_city}
        error={errors.address_city}
        isRequired
        {...getFieldProps("address_city")}
      />
      <Input
        label="State"
        isInvalid={touched.address_state && !!errors.address_state}
        error={errors.address_state}
        isRequired
        {...getFieldProps("address_state")}
      />
      {!hidePostalCode && (
        <Input
          label="Postal Code"
          isInvalid={touched.address_postal_code && !!errors.address_postal_code}
          error={errors.address_postal_code}
          isRequired
          {...getFieldProps("address_postal_code")}
        />
      )}
      <CountrySelect selectedCountry={country} fieldName="address_country_code" setFieldValue={setFieldValue} />
    </>
  );
};

export const EntityAddressForm = ({ errors, touched, getFieldProps, values, setFieldValue, onAddressSelect }) => {
  const country = getFieldProps("entity_address_country_code").value;
  const street1Props = getFieldProps("entity_address_street_1");
  const hidePostalCode = usePostalCodeExcluded(country, getFieldProps("entity_address_postal_code").value, () =>
    setFieldValue("entity_address_postal_code", ""),
  );

  return (
    <>
      <StreetAutocompleteInput
        label="Street Address"
        isInvalid={touched.entity_address_street_1 && !!errors.entity_address_street_1}
        isRequired
        error={errors.entity_address_street_1}
        onSelected={onAddressSelect}
        {...street1Props}
      />
      <Input
        label="Street Address 2 (Unit #)"
        isInvalid={touched.entity_address_street_2 && !!errors.entity_address_street_2}
        error={errors.entity_address_street_2}
        {...getFieldProps("entity_address_street_2")}
      />
      <Input
        label="City"
        isInvalid={touched.entity_address_city && !!errors.entity_address_city}
        error={errors.entity_address_city}
        isRequired
        {...getFieldProps("entity_address_city")}
      />
      <Input
        label="State"
        isInvalid={touched.entity_address_state && !!errors.entity_address_state}
        error={errors.entity_address_state}
        isRequired
        {...getFieldProps("entity_address_state")}
      />
      {!hidePostalCode && (
        <Input
          label="Postal Code"
          isInvalid={touched.entity_address_postal_code && !!errors.entity_address_postal_code}
          error={errors.entity_address_postal_code}
          isRequired
          {...getFieldProps("entity_address_postal_code")}
        />
      )}
      <CountrySelect selectedCountry={country} fieldName="entity_address_country_code" setFieldValue={setFieldValue} />
    </>
  );
};
